import BaseModel from './BaseModel'

export default class PropositionModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      PROPOSITION: null,
      CODE_REF_COACH: null,
      DATE_RECEPTION_COMMANDE: '',
      INFORMATIONS_SUIVI_COMMERCIAL: '',
      OPTIONS: []
    }
    super(data, relation, fields)
  }
}
